import {Injectable} from '@angular/core';
import 'rxjs/add/operator/map';

// Classes.
import {LoggedComponent} from '../logger/logged-component';

// Services.
import {LoggerService} from '../logger/logger-service';
import {EnvironmentService} from './environment-service';


/**
 *
 */
@Injectable()
export class WABaseService extends LoggedComponent {

  constructor(
    protected logger: LoggerService,

    protected env: EnvironmentService) {
    super(logger);

    if (env.isDev()) {
      if (typeof window['WA'] === 'undefined') {
        window['WA'] = {};
      }

      if (typeof window['WA']['srvcs'] === 'undefined') {
        window['WA']['srvcs'] = {};
      }
      window['WA']['srvcs'][this.componentName] = this;
    }
  }
}
